import { render, staticRenderFns } from "./BezorglijstBase.vue?vue&type=template&id=1592d832&scoped=true&"
import script from "./BezorglijstBase.vue?vue&type=script&lang=js&"
export * from "./BezorglijstBase.vue?vue&type=script&lang=js&"
import style0 from "./BezorglijstBase.vue?vue&type=style&index=0&id=1592d832&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1592d832",
  null
  
)

export default component.exports